import React from 'react';
import { Row, Col } from 'bs';

export const ErrorPage = props => {
    const title = props.title || 'There was an unexpected error.';
    const details =
        props.details || "We've been alerted about the problem and will fix it ASAP.";

    return (
        <Row className='justify-content-md-center'>
            <Col className='mt-5 text-center'>
                <h1 className='text-muted'>{title}</h1>
                <p className='lead'>{details}</p>
            </Col>
        </Row>
    );
};

export default ErrorPage;
